module.exports = __webpack_public_path__ + "img/path-4.a6cf1961.svg";